import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { RealEstatePoliceService, ERealEstateBoard } from '../../../services/RealEstatePoliceService/real.estate.police.service';
import * as T_T from 'cryface';

@Component
export default class PropertyDisclaimer extends Vue {
   public title: string = 'PropertyDisclaimer';
   public policeService = new RealEstatePoliceService();
   public police = this.policeService.claimAlpha.content;

   @Prop()
   public realEstateBoard: any;

   @Prop()
   public data: any;

   @Watch('data', { immediate: true, deep: true })
   public onDataInput(val: any, oldVal: any) {
   }

   @Watch('$store.state.auth.storeInfo', { immediate: true, deep: true })
   public async onStoreChanged(val: any, oldVal: any) {
      if (T_T.simpleDetect(val.value)) {
         if (val.value.template === ERealEstateBoard.rebgv) {
            this.police = this.policeService.claimBeta.content;
         }
      }
   }

   @Watch('realEstateBoard', { immediate: true, deep: true })
   public async onRealEstateBoardChanged(val: any, oldVal: any) {
      if (T_T.simpleDetect(val)) {
         console.log(val, 'realEstateBoard');
         if (val === 'rebgv') {
            this.police = this.policeService.claimBeta.content;
         } else {
            this.police = this.policeService.claimAlpha.content;
         }
      }
   }
}
